// import "babel-polyfill";
import Vue from "vue";
import App from "./AppH5";
import router from "./router";
import './AppConfigH5/flyio';//引入flyio配置
import store from "@/vuex/index";//引入vuex状态管理器
import './assets/css/ydd.css';//引入清样式的css
import './AppConfigH5/cube-ui';
import wx from 'weixin-js-sdk';
// import Vconsole from 'vconsole';

// new Vconsole();
const Base64 = require('js-base64').Base64
Vue.config.productionTip = false;
Vue.mixin({
    data () {
      return {
        // service: 'https://api.txzfw.kcshop.vip/', // 服务
        service: 'https://apidgybwj.kuaichuangkeji.com/', // 服务
        router: '/', // 路由路径
        imgSrc: '' // 图片路径
      }
    },
    methods: {
        // wechat(){
        //     var local = window.location.href;
        //     this.$http.get(`${this.service}wechat/share`,{
        //         url:local,
        //     }).then((data)=>{
        //     console.log(data,'jssdk')
        //     let fenx ={
        //       shareTitle:'东莞医保服务满意度调查活动',
        //       shareDesc:"快来参与“东莞医保服务满意度调查活动”，领取微信红包!",
        //       shareURL:'http://wechat.dgybwj.kuaichuangkeji.com',
        //     }
        //     wx.config({
        //       debug:true,
        //       appId: data.appId,
        //       timestamp: data.timestamp,
        //       nonceStr: data.nonceStr,
        //       signature: data.signature,
        //       jsApiList: [
        //         'checkJsApi',
        //         'onMenuShareTimeline',
        //         'onMenuShareAppMessage',
        //         'openLocation',
        //         'onMenuShareQQ',
        //         'onMenuShareWeibo',
        //         'hideMenuItems',
        //         'showMenuItems',
        //         'hideAllNonBaseMenuItem',
        //         'showAllNonBaseMenuItem'
        //       ]
        //     });
        //     wx.ready(function(){
        //       wx.onMenuShareAppMessage({
        //         title:fenx.shareTitle,
        //         desc:fenx.shareDesc,
        //         link:fenx.shareURL,
        //         imgUrl:'http://wechat.dgybwj.kuaichuangkeji.com/static/img/weix.png',
        //         success:function(item){
        //           console.log('分享成功')
        //         },
        //         cancel:function(){
        //           console.log('分享失败')
        //         }
        //       });
        //       wx.onMenuShareTimeline({
        //         title:fenx.shareTitle,
        //         desc:fenx.shareDesc,
        //         link:fenx.shareURL,
        //         imgUrl:'http://wechat.dgybwj.kuaichuangkeji.com/static/img/weix.png',
        //         success:function(){
        //           console.log('分享成功')
        //         },
        //         cancel:function(){
        //           console.log('分享失败')
        //         }
        //       });
        //     });
        //   })
        // },
        newroot () {
            return  this.$route
        },
        navigatePageTo (url) {
            this.$router.push(url);
        },
        reLaunchPageTo (url) {
            this.$router.replace(url)
        },
        getStorageSync(name){
            let data = localStorage.getItem(name);
            if(data){
                return JSON.parse(data);
            }
        },
        setStorageSync(name,data){
            if(typeof data == 'object'){
                data = JSON.stringify(data)
            }
            localStorage.setItem(name,data) 
        },
        getwindowHeight(){
           return document.body.getBoundingClientRect().height; 
        }
    },
  })
/* eslint-disable no-new */
new Vue({
    el: "#app",
    Base64,
    store,
    router,
    template: "<App/>",
    components: { App }
});


// WEBPACK FOOTER //
// ./src/mainH5.js